<script setup>
import {computed, onMounted, onUnmounted, ref, watch} from 'vue'
import PieChart from '@/components/charts/nChartsPie.vue'
import {destory, developerOptions} from './index'
import BarAndLineChart from '@/components/charts/nChartBarAndLine.vue'
import request from "@/service/request";
import {
  getDeveloper,
  GetProjectByRptNumber,
  getProjectDetail,
  GetProjectInsightList,
  getProjectOverview
} from "@/service/api";
import InfoRow from "@/view/insight/project/components/infoRow.vue";
import {Search} from "@element-plus/icons-vue";
import ImageView from "@/view/insight/project/components/imageView.vue";
import FloorInfo from "@/components/floorInfo.vue";
import RateFormater from "@/view/insight/project/components/rateFormater.vue";
import NoData from "@/components/noData.vue";
import {
  emptyArray,
  rentPriceFormat,
  UNIT_BEARING,
  vacancyRateNoSuffix, vacancyRateWithSuffix,
  warehouseArea
} from "@/tool/number";
import {uniqueFloor} from "@/tool/array";
import TabButtonGroup from "@/components/tabButtonGroup.vue";
import {useRoute} from "vue-router";
import MessageHeader from "@/components/MessageHeader.vue";

let projectName = null;
let cityList = JSON.parse(localStorage.getItem('cityList'))
let time = localStorage.getItem('time')
let mapTime = localStorage.getItem('mapTime')
let projectValue = ref('');
let projectList = ref([])
let selectCity = ref('')
let selectDevelop = ref('')
let timeout = null
let tabsValue = ref(1)

// 总览
let overviewInfo = ref(null)
const getProjectInfo = async () => {
    let obj = projectList.value.find(item => item.projectName === projectValue.value)
    if(!obj) return ;
    let {data} = await request({
        url: getProjectOverview,
        method: "post",
        data: {
            rptId: obj.rptId,
            quarter: mapTime,
            isHighBar: 1
        }
    })
    data.trendChartList.map
    overviewInfo.value = {
        ...data
    }
}

const extraFloorHeight = computed(() => {
  let arr = (detailInfo.value.warehouseWeight || []);
  return uniqueFloor(arr, (o) => ({key: o.floornumber, value: o.floorheight}))
})

const extraFloorBearing = computed(() => {
  let arr = (detailInfo.value.warehouseWeight || []);
  return uniqueFloor(arr, (o) => ({key: o.floornumber, value: o.bearing}))
})

// 项目详情
let detailInfo = ref({
    imagelist:[]
})
const getDetail = async () => {
    let obj = projectList.value.find(item => item.projectName === projectValue.value)
    if(!obj) return;
    let {data} = await request({
        url: getProjectDetail,
        method: "post",
        data: {
            rptId: obj.rptId,
            quarter: mapTime,
            isHighBar: 1,
            rptNumber: obj.rptNumber
        }
    })
    if(data.tenantcategoryrates) {
        let num = 0
        data.tenantcategoryrates.forEach(item => {
            num += item.counts
        })
        data.tenantcategoryrates =  data.tenantcategoryrates.map(item => {
            let rate = item.counts / num * 100
            return {
                name: item.category,
                value: rate
            }

        })
    }
    detailInfo.value = data
}

// {
//   "vacancyrateMetric":{"metricValue":0,"metricValueYOY":0,"metricValueMOM":0},
//   "estimatedEffectiveMetric":{"metricValue":45,"metricValueYOY":-0.169,"metricValueMOM":0}
// }
// 空置率
const vacancyValue = computed(() => {
  return getRateValue(overviewInfo, ['vacancyrateMetric', 'metricValue'])
})

const vacancyYoYValue = computed(() => {
  return getValue(overviewInfo, ['vacancyrateMetric', 'metricValueYOY'])
})

const vacancyMoMValue = computed(() => {
  return getValue(overviewInfo, ['vacancyrateMetric', 'metricValueMOM'])
})

// 预估有效租金
const effectiveValue = computed(() => {
  return getValue(overviewInfo, ['estimatedEffectiveMetric', 'metricValue'])
})

const effectiveYoYValue = computed(() => {
  return getValue(overviewInfo, ['estimatedEffectiveMetric', 'metricValueYOY'])

})

const effectiveMoMValue = computed(() => {
  return getValue(overviewInfo, ['estimatedEffectiveMetric', 'metricValueMOM'])
})
const lastQuarterMetricKzlValue = computed(() => {
  return getYxzjValue(overviewInfo, ['vacancyrateMetric', 'lastQuarterMetricValue'])
})
const lastYearMetricKzlValue = computed(() => {
  return getYxzjValue(overviewInfo, ['vacancyrateMetric', 'lastYearMetricValue'])
})
const lastQuarterMetricYxValue = computed(() => {
  return getYxzjValue(overviewInfo, ['estimatedEffectiveMetric', 'lastQuarterMetricValue'])
})
const lastYearMetricKzlYxValue = computed(() => {
  return getYxzjValue(overviewInfo, ['estimatedEffectiveMetric', 'lastYearMetricValue'])
})

function getYxzjValue(obj, keys){
  console.log('7777777777777777777777777777777');
  console.log(obj);
  
  
  if(!obj.value){
    return null;
  }
  let result = obj.value;
  for(let i in keys){
    let key = keys[i]
    console.log(key);
    
    if(result[key] === null || result[key] === undefined){
      return null;
    }else{
      result = result[key];
    }
  }
  console.log('9999999999999999999999999999999999');
  console.log(result);
  
  
  return result;
}

function showValue(v){
  return v === null ? '-' : v;
}

function getRateValue(obj, keys){
  let v = getValue(obj, keys);
  if(v === undefined || v === null){
    return null;
  }else{
    return Number(v * 100).toFixed(2) + '%'
  }
}

function getValue(obj, keys){
  if(!obj.value){
    return null;
  }
  let result = obj.value;
  for(let i in keys){
    let key = keys[i]
    if(result[key] === null || result[key] === undefined){
      return null;
    }else{
      result = result[key];
    }
  }
  
  return Number(result);
}


/*园区地址*/
const warehouseAddress = computed(() => {
  let city = (detailInfo.value.province === detailInfo.value.city) ? '': detailInfo.value.province;
  let address = (detailInfo.value.city+detailInfo.value.area+ detailInfo.value.address);
  return `${city}${address}`;
})
/*建成时间*/
const buildingTime = computed(() => detailInfo.value.maxBuiltTime?new Date(detailInfo.value.maxBuiltTime).format('yyyy/MM'):'/')


const changeTableValue = (value) => {
  tabsValue.value = value + 1;
}

async function initPage(){
  const route = useRoute();
  let {rptNumber} = route.query;
  if(rptNumber){
    // 获取项目城市和名称
    let {data} = await getProjectByRptNumber(rptNumber);
    projectName = data.projectName;
    selectCity.value = data.cityCode;
  }else{
    selectCity.value = cityList[0].cityCode;
  }
  await getDeveloperList();
}
async function getProjectByRptNumber(rptNumber){
  return await request({
    method: 'get',
    url: GetProjectByRptNumber,
    data: { rptNumber }
  })
}


const getDeveloperList = async () => {
  let {data} = await request({
    url: getDeveloper,
    method: "post",
    data: {
      quarter: mapTime,
      isHighBar: 1
    }
  })
  developerOptions.value = data
  selectDevelop.value = data[0]
}

const getProject = async () => {
  let params = {
    quarter: mapTime,
    cityCode: selectCity.value,
    projectDeveloper:selectDevelop.value
  }
  tabsValue.value===1?  delete  params.projectDeveloper:delete params.cityCode
  let {data} = await request({
    url: GetProjectInsightList,
    method: "post",
    data: {...params}
  })
  projectList.value = data || []
  if(projectName){
    projectValue.value = projectName;
    projectName = null;
  }else{
    projectValue.value = data.length?data[0].projectName:''
  }
}

const maxFloorHeight = computed(() => {
  return extraFloorHeight.value.max;
})


const maxFloorBearing = computed(() => {
  return extraFloorBearing.value.max;
})

watch([selectCity, selectDevelop], () => {
    if(timeout) clearTimeout(timeout);
    timeout = setTimeout(()=>{
       getProject()
       clearTimeout(timeout);
    },1000)
})

watch(projectValue, () => {
  getProjectInfo()
  getDetail()
})

watch(tabsValue,async()=>{
    if(tabsValue.value===1) {
        selectDevelop.value = ''
        selectCity.value = cityList[0].cityCode
    } else {
        selectDevelop.value = developerOptions.value['0']
        selectCity.value = ''
    }
})


onMounted(initPage);
onUnmounted(destory);
</script>
<template>
    <div class="u-agg-box">
        <div class="u-agg-content">
            <div class="u-agg-top">
                <p>项目数据概览</p>
                <span>数据时间：{{ time }}</span>
            </div>
            <div class="u-agg-tabs">
              <tab-button-group
                  :data="['按城市', '按开发商']"
                  @onChangeTab="changeTableValue"
              />
              <div class="u-agg-tab-content">
                    <div v-show="tabsValue === 1" class="u-agg-tab">
                        <el-select v-model="selectCity" filterable placeholder="请选择" :suffix-icon="Search">
                            <el-option v-for="item in cityList" :key="item.cityCode" :label="item.name"
                                       :value="item.cityCode"/>
                        </el-select>
                        <div style="width:10px"></div>
                        <el-select v-model="projectValue" filterable placeholder="请选择" :suffix-icon="Search">
                            <el-option v-for="(item,index) in projectList" :key="index" :label="item.projectName"
                                       :value="item.projectName"/>
                        </el-select>
                        <!--                        <el-cascader placeholder="请选择" :options="cityOptions" filterable />-->
                    </div>
                    <div v-show="tabsValue === 2" class="u-agg-tab">
                        <el-select v-model="selectDevelop" filterable placeholder="请选择" :suffix-icon="Search">
                            <el-option v-for="item in developerOptions" :key="item" :label="item"
                                       :value="item"/>
                        </el-select>
                        <div style="width:10px"></div>
                        <el-select v-model="projectValue" filterable placeholder="请选择" :suffix-icon="Search">
                            <el-option v-for="(item,index) in projectList" :key="index" :label="item.projectName"
                                       :value="item.projectName"/>
                        </el-select>
                    </div>
                </div>
            </div>

          <div class="u-agg-overview">
            <message-header
              :msg="detailInfo ? detailInfo.projectName : ''"
            />
            <div class="warehouse-address-wrapper">
              <info-row name="开发商" :value="detailInfo.projectDeveloper" :category="1"></info-row>
              <info-row name="园区地址" :value="warehouseAddress" class="warehouse-address-row2" :category="1"></info-row>
            </div>
          </div>

<!--园区数据总览-->
            <div class="u-agg-overview">
                <message-header
                  msg="园区数据总览"
                />
                <div class="top-total-show">
                  <ul class="u-agg-dlist">
                    <li class="dlist-item-bg1">
                      <div class="dlist-bgb-block dlist-bgb1"></div>
                      <div class="dlist-item-info">
                        <div class="dlist-itemi-total">
                          <div class="dlist-itemi-title">
                            <span class="dlist-itemi-name">仓库总面积</span>
                            <div class="dlist-itemi-tip">
                              <el-tooltip content="包含建成面积和在建面积" effect="light" placement="top">
                                <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                              </el-tooltip>
                            </div>
                          </div>
                          <div class="dlist-itemi-count">
                            <span>{{warehouseArea(detailInfo.totalArea)}}</span>㎡
                          </div>
                        </div>
                        <div class="dlist-itemi-detail">
                          <div class="dlist-itemi-dname">建筑状态</div>
                          <div class="dlist-item1-dcount">
                            <span>{{detailInfo.buildingState  }}</span>
                          </div>
                        </div>

                        <div class="dlist-itemi-detail">
                          <div class="dlist-itemi-dname">建筑类型</div>
                          <div class="dlist-item1-dcount">
                            <span>{{detailInfo.rptBuildingTypeNames  }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="dlist-itemi-detail" style="position: absolute; right: 28%; top: 12%;">
                        <div class="dlist-itemi-dname">在建面积</div>
                        <div class="dlist-item1-dcount">
                          <span>{{ warehouseArea(detailInfo.buildingArea) }}</span>㎡
                        </div>
                      </div>
                    </li>
                    <li class="dlist-item-bg2">
                      <div class="dlist-bgb-block dlist-bgb2"></div>
                      <div class="dlist-item-info">
                        <div class="dlist-itemi-total">
                          <div class="dlist-itemi-title">
                            <span class="dlist-itemi-name">空置率</span>
                          </div>
                          <div class="dlist-itemi-count">
                            <span>{{ showValue(vacancyValue) }} </span>
                          </div>
                        </div>

                        <div class="dlist-itemi-detail">
                          <ul>
                            <li class="ulLi">
                              <div class="dlist-itemi-dname">环比</div>
                              <rate-formater :value="vacancyMoMValue" />
                            </li>
                            <li class="ulLi">
                              <div class="dlist-itemi-dname">上季度</div>
                              <!-- <rate-formater :value="lastYearMetricKzlValue" /> -->
                              <span class="preVale">{{lastYearMetricKzlValue}}</span>
                            </li>
                          </ul>
                          
                        </div>

                        <div class="dlist-itemi-detail">
                          <ul>
                            <li class="ulLi">
                              <div class="dlist-itemi-dname">同比</div>
                              <rate-formater :value="vacancyYoYValue" />
                            </li>
                            <li class="ulLi">
                               <div class="dlist-itemi-dname">上一年</div>
                              <!-- <rate-formater :value="lastQuarterMetricKzlValue" /> -->
                              <span class="preVale">{{lastQuarterMetricKzlValue}}</span>
                              
                            </li>
                          </ul>
                          
                        </div>

                      </div>
                    </li>
                    <li class="dlist-item-bg3">
                      <!--  <div class="dlist-bgb-block dlist-bgb3"></div>-->
                      <div class="dlist-item-info">
                        <div class="dlist-itemi-total">
                          <div class="dlist-itemi-title">
                            <span class="dlist-itemi-name">预估有效租金</span>
                            <div class="dlist-itemi-tip">
                              <el-tooltip content="折算免租期、装修期后的租金" effect="light" placement="top">
                                <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                              </el-tooltip>
                            </div>
                          </div>
                          <div class="dlist-itemi-count">
                            <span>{{ rentPriceFormat(effectiveValue) }}</span>
                            元/㎡·月
                          </div>
                        </div>
                        <div class="dlist-itemi-detail">
                          <ul>
                            <li class="ulLi">
                              <div class="dlist-itemi-dname">环比</div>
                              <rate-formater :value="effectiveMoMValue" />
                            </li>
                            <li class="ulLi">
                             <div class="dlist-itemi-dname">上季度</div>
                              <span class="preVale">{{lastYearMetricKzlYxValue}}<span class="prelastYear"> 元/㎡·月</span></span>
                            </li>
                          </ul>
                          
                        </div>
                        <div class="dlist-itemi-detail">
                          <ul>
                            <li class="ulLi">
                              <div class="dlist-itemi-dname">同比</div>
                              <rate-formater :value="effectiveYoYValue" />
                            </li>
                            <li class="ulLi">
                               <div class="dlist-itemi-dname">上一年</div>
                              <span class="preVale">{{lastQuarterMetricYxValue}}<span class="prelastYear"> 元/㎡·月</span></span>
                              
                            </li>
                          </ul>
                          
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              <!--                  <ul class="u-agg-dlist" style="flex: auto; margin-left: 20px; column-gap: 20px;">-->
              <!--                    <li class="dlist-item-bg4" style="flex:1; padding: 20px;">-->
              <!--                      <p class="u-agg-aii-ct">租户行业分布</p>-->
              <!--                      <div class="u-agg-chart-industry-content">-->
              <!--                        <PieChart :data="detailInfo.tenantcategoryrates||[]"></PieChart>-->
              <!--                      </div>-->
              <!--                    </li>-->
              <!--                    <li class="dlist-item-bg5" style="flex:1; padding: 20px;">-->
              <!--                      <p class="u-agg-aii-ct">预估有效租金及空置率趋势图</p>-->
              <!--                      <BarAndLineChart :labelOptions="['','%']" :data="overviewInfo?overviewInfo.trendChartList:[]"  :options="['quarter','estimatedEffective','vacancyrate']" color="#54DD88" not-show-y-name></BarAndLineChart>-->
              <!--                    </li>-->
              <!--                  </ul>-->

                <div class="u-agg-chart-list">
                  <div class="u-agg-ovinfor-block">
                    <p class="u-agg-aii-ct">预估有效租金及空置率趋势图</p>
                    <BarAndLineChart
                        :labelOptions="['', '']"
                        :data="overviewInfo?overviewInfo.trendChartList:[]"
                        :options="['quarter','estimatedEffective','vacancyrate']"
                        :value-format="[rentPriceFormat, vacancyRateWithSuffix]"
                        color="#54DD88"
                        :label-format="['(元/㎡·月)', '']"
                        not-show-y-name
                    />
                  </div>
                  <div class="u-agg-ovinfor-block">
                    <p class="u-agg-aii-ct">租户行业分布</p>
                    <div class="u-agg-chart-industry-content" style="position: relative">
                      <no-data
                          :visible="emptyArray(detailInfo.tenantcategoryrates)"
                      />
                      <PieChart
                          :data="detailInfo.tenantcategoryrates || []"
                      />
                    </div>
                  </div>
                </div>
            </div>

<!--项目详情-->
            <div class="u-agg-overview" style="margin-top: 40px">
              <message-header msg="仓库情况"/>
              <div class="u-warehouse-detail" style="height: auto">
                <div class="u-agg-ovinfo-block2 u-agg-ovinfo-left" style="min-width: 0;">
                    <div class="u-agg-ovinfol-imgswiper">
<!--                        <div class="u-agg-ovinfol-is">-->
<!--                          <div class="swiper u-agg-ovinfol-swiper">-->
<!--                                <div class="swiper-wrapper">-->
<!--                                    <div class="swiper-slide" style="width: 30%" :key="index" v-for="(item,index) in detailInfo.imagelist">-->
<!--                                        <img :src="item" />-->
<!--                                        <div class="u-agg-ovinfol-whtype">平库</div>-->
<!--                                        <div class="u-agg-ovinfol-whstatus">已建成</div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                          </div>-->
<!--                        </div>-->
                       <div class="u-agg-ovinfol-thumbs">
                         <image-view
                            :src-list="detailInfo.imagelist"
                         />

<!--                              <div class="u-agg-ovinfol-sw-btn u-agg-sw-btn-left"><span class="iconfont icon-jiantou-xiangzuo"></span></div>-->
<!--                              <div class="swiper u-agg-ovinfol-swiper-thumbs u-swiper">-->
<!--                                  <div class="swiper-wrapper">-->
<!--                                      <div class="swiper-slide" v-for="(item, index) in detailInfo.imagelist">-->

<!--                                           <img :src="item" style="width: 100%;height: 100%;" @click="previewImage(item)"/>-->
<!--                                          <div class="u-agg-swiper-thumbs-mask"></div>-->
<!--                                      </div>-->
<!--                                  </div>-->
<!--                              </div>-->


<!--                              <div class="u-agg-ovinfol-sw-btn u-agg-sw-btn-right"><span class="iconfont icon-jiantou-xiangyou"></span></div>-->
                          </div>
                    </div>
                </div>

                <div class="u-agg-ovinfo-block1 u-agg-ovinfo-left">
                  <div class="u-agg-ovinfo-detail">
                    <div>
                      <div>
                        <div>
                            <info-row name="建成时间" :value="buildingTime"></info-row>
                            <info-row name="防火等级" :value="detailInfo.fireLevel"></info-row>
                            <info-row name="卸货方式" :value="detailInfo.dischargeCargo"></info-row>
                            <info-row name="月台类型" :value="detailInfo.platformType"></info-row>
                            <info-row name="层数" :value="detailInfo.floorNumber"></info-row>
                            <info-row name="净高（m）" :value="maxFloorHeight" dot>
                              <template #default>
                                <floor-info :extra="extraFloorHeight"></floor-info>
                              </template>
                            </info-row>
                            <info-row :name="`承重（${UNIT_BEARING}）`" :value="maxFloorBearing" dot>
                              <template #default>
                                <floor-info :extra="extraFloorBearing"></floor-info>
                              </template>
                            </info-row>
                            <info-row name="雨棚深度（m）" :value="detailInfo.awningDimension"></info-row>
                          </div>
                        <div class="u-agg-oxm-item" v-if="detailInfo.landtransactions&&detailInfo.landtransactions.length">
                          <span class="u-agg-oxm-pt">土地信息</span>
                          <div class="u-agg-oxm-info">
                            <div class="u-agg-oxmi-item">
                              <span class="u-agg-oxm-title">宗地编号</span>
                              <span class="u-agg-oxm-text">{{detailInfo.landtransactions[0].code }}</span>
                            </div>
                            <div class="u-agg-oxmi-item">
                              <span class="u-agg-oxm-title">成交价</span>
                              <span class="u-agg-oxm-text u-agg-oxm-t-keynote"><b>{{detailInfo.landtransactions[0].finalPrice }}</b>元</span>
                            </div>
                            <div class="u-agg-oxmi-item">
                              <span class="u-agg-oxm-title">土地面积</span>
                              <span class="u-agg-oxm-text u-agg-oxm-t-keynote"><b>{{detailInfo.landtransactions[0].area  }}</b>亩</span>
                            </div>
                            <div class="u-agg-oxmi-item">
                              <span class="u-agg-oxm-title">竞得公司</span>
                              <span class="u-agg-oxm-text">{{detailInfo.landtransactions[0].bidder }}</span>
                            </div>
                            <div class="u-agg-oxmi-item">
                              <span class="u-agg-oxm-title">成交时间</span>
                              <span class="u-agg-oxm-text">{{detailInfo.landtransactions[0].transactionTime}}</span>
                            </div>
                            <div class="u-agg-oxmi-item">
                              <span class="u-agg-oxm-title">土地性质</span>
                              <span class="u-agg-oxm-text">{{detailInfo.landtransactions[0].landUse  }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
@import "../../../assets/css/public.less";
@import "../urbanAgglomerations/index.less";
@import "./index.less";

.el-image-viewer__canvas{
  width: 100%;
  height: 100%;
}


.u-swiper{
  overflow-x: auto;
}

div.u-no-align-between{
  justify-content: normal;
}
.dlist-item1-chain-hidden.iconfont{
  display: none;
}
.u-agg-chart-list{
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  column-gap: 20px;
}
.u-warehouse-detail{
  display: flex;
  column-gap: 20px;
  margin: 20px 0;
}
.u-agg-ovinfo-block2{
  flex: 1;
}
.u-agg-ovinfo-left.u-agg-ovinfo-block1{
  width: 352px;
}

.warehouse-address-wrapper{
  margin: 20px 0;
  display: flex;
  flex-direction: row;
}

.warehouse-address-row2{
  margin-left: 30px;
}

.top-total-show{
  display: flex;
  flex-direction: row;
  row-gap: 20px;
}

.dlist-itemi-tip .iconfont{
  font-size: 12px;
  position: relative;
  top: -6px;
}
.ulLi{
    height: auto !important;
    width: 50% !important;
    float: left;
}
.preVale{
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  margin-top: 6px;
  color: #a8a8a8;;
}

.prelastYear {
    font-size: 11px;
}
</style>